module.exports = __webpack_public_path__ + "static/media/postres.893eb55c.jpg";